// extracted by mini-css-extract-plugin
export default {"redesign":"SwipeableOffcanvas_redesign__6nlnu"};